<template>
  <span>
    Group
    <em>users</em>
    to efficiently connect them to your IT resources (SSO apps, LDAP resources, networks, and more).
  </span>
</template>

<script>
export default {
  name: 'InstructionTextUserGroups',
};
</script>
